/**
* Card Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'card-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      let navHeight = $( '.navbar' ).outerHeight();
      let triggerPos = 0;

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      triggerPos += navHeight;
      triggerPos += 64;

      const innerWidth = $( '.card-scroller .card' ).outerWidth() * $( '.card-scroller .card' ).length;
      const sections = gsap.utils.toArray( '.card-scroller .card' );

      let sectionsLength = sections.length - 0.25;

      if ( window.innerWidth > 1269 ) {
        sectionsLength = sections.length - 2.5;
      } else if ( window.innerWidth < 1269 && window.innerWidth > 1024 ) {
        sectionsLength = sections.length - 2;
      } else if ( window.innerWidth < 600 ) {
        sectionsLength = sections.length - 0.45;
      } else {
        sectionsLength = sections.length - 0.85;
      }

      gsap.to( sections, {
        xPercent: -100 * sectionsLength,
        scrollTrigger: {
          trigger: '.card-scroller .cards',
          start: 'top ' + ( triggerPos + 24 ),
          end: () => '+=' + innerWidth,
          scrub: true,
          pin: true,
          refreshPriority: 2,
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-scroller', COMPONENT );
} )( app );
